import React from 'react';
import { Link, withRouter } from '@americanexpress/one-app-router';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getLocaleData } from '@/selectors/localeSelectors';
import { isNewUrl, getBasePathFromLocation, cn } from '@/helpers/utils';
import { useAnalyticsContext } from '@/context/analyticsContext';

const LFLink = ({
  to: path,
  pathname,
  element,
  router,
  className,
  ...restOfProps
}) => {
  const { locale } = useSelector(getLocaleData);
  const { customTrack } = useAnalyticsContext();
  const basePath = getBasePathFromLocation(locale, router.location.pathname);
  const queryParamsWithoutLocale = new URLSearchParams(router.location.search);
  queryParamsWithoutLocale.delete('locale'); // remove the locale
  const destination = path.startsWith('http') ? path : `${basePath}/${path}`;

  const handleClick = (event) => {
    customTrack({
      event,
      detail: restOfProps.detail || '',
      element: element || '',
    });
  };

  return (
    <Link
      className={cn('tw-no-underline', className)}
      to={{
        pathname: pathname || destination,
        search: isNewUrl(router.location.pathname)
          ? `?${queryParamsWithoutLocale}`
          : pathname
            ? ''
            : router?.location?.search,
      }}
      onClick={handleClick}
      {...restOfProps}
    />
  );
};

LFLink.propTypes = {
  to: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  detail: PropTypes.string,
  element: PropTypes.string,
  className: PropTypes.string,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.shape({}),
      search: PropTypes.string,
    }),
  }),
};

LFLink.defaultProps = {
  pathname: '',
  detail: '',
  element: '',
  className: '',
  router: {},
};

export default withRouter(LFLink);
